import React, { useEffect, useRef, useState } from "react";
import bwipjs from "bwip-js";
import theme from "../../../Styles/theme";
import { Container } from "./styles";
import { retiraVerificadores } from "../../../Utils/retiraVerificadores";
import { adicionaDigitos } from "./adicionaDigitos";
import { IAdquirinte } from "../../../Storage/Adquirente";
import { api_pix } from "../../../Utils/baseUrl";
import axios from "axios";

interface Props {
  code: string;
  prova: string;
  febraban: string;
  adquirente: IAdquirinte;
  valor: number;
  vencimento: string;
  id_entidade: number;
  id_imovel: number;
}

type PixData = {
  pixCopiaECola: string;
  qrBase64: string;
};

function GuiaCode({
  code,
  prova,
  febraban,
  adquirente,
  valor,
  vencimento,
  id_entidade,
  id_imovel,
}: Props) {
  const [okay, setOkay] = useState(false);
  const [pix, setPix] = useState<PixData | null>(null);
  const [pixLoading, setPixLoading] = useState(false);

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    async function carregarTudo() {
      try {
        const teste = retiraVerificadores(code || "");
        const numeroExtraido = teste.substring(14, 18);
        //window.alert( febraban+"-"+ numeroExtraido)
        if (numeroExtraido === String(febraban)) {
          setOkay(true);

          if (canvasRef.current) {
            bwipjs.toCanvas(canvasRef.current, {
              bcid: "interleaved2of5",
              text: code.length === 48 ? retiraVerificadores(code) : code,
              scale: 1,
              height: 20,
              includetext: false,
              textxalign: "center",
            });
          }
        } else {
          setOkay(false);
        }

        const pixData = await carregarPix();
        setPix(pixData);
      } catch (e) {
        setOkay(false);
        setPix(null);
      }
    }

    carregarTudo();

    if (code) {
      console.log("Barcode Final: ", retiraVerificadores(code));
    }
  }, [code, prova, febraban, adquirente, valor, vencimento, id_entidade, id_imovel]);

  async function carregarPix(): Promise<PixData | null> {
    setPixLoading(true);

    try {
      const codigo = retiraVerificadores(code);
      if (!codigo) return null;

      try {
        const response = await axios.post(`${api_pix}`, {
          id_entidade: id_entidade,
          valor: valor,
          dataDeVencimento: vencimento.toString().substring(0, 10),
          cod_barras: codigo,
          nome:adquirente.NOME,
          cpf_cnpj: adquirente.CNPJ || adquirente.CPF,
          carne: id_imovel,
        });

        const data = response.data;

        if (
          !data ||
          !data.status ||
          !data.data ||
          !data.data.pixCopiaECola ||
          !data.data.qrBase64
        ) {
          return null;
        }

        return {
          pixCopiaECola: data.data.pixCopiaECola,
          qrBase64: data.data.qrBase64,
        };
      } catch (error) {
        return null;
      }
    } finally {
      setPixLoading(false);
    }
  }

  return (
    <Container
      className="App"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        zoom: 2.5,
        transformOrigin: "top center",
        width: "100%",
      }}
    >
      {!okay && (
        <p
          style={{
            color: theme.colors.attention,
            fontWeight: "bold",
            fontSize: "14px",
            margin: 0,
          }}
        >
          FEBRABAN NÃO FOI CARREGADO CORRETAMENTE
        </p>
      )}

      {okay && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: pix ? "center" : "center",
            alignItems: "flex-end",
            gap: pix ? "18px" : "0px",
            marginTop: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <canvas ref={canvasRef}></canvas>

            {code.length === 48 ? (
              <span
                style={{
                  marginTop: "4px",
                  fontSize: "12px",
                  color: "#000",
                  textAlign: "center",
                  letterSpacing: "0.5px",
                }}
              >
                {code}
              </span>
            ) : null}

            {code.length === 44 ? (
              <span
                style={{
                  marginTop: "4px",
                  fontSize: "12px",
                  color: "#000",
                  textAlign: "center",
                  letterSpacing: "0.5px",
                }}
              >
                {adicionaDigitos(code)}
              </span>
            ) : null}
          </div>

          {!!pix && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
                minWidth: "110px",
              }}
            >
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "#000",
                  marginBottom: "4px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Pague com PIX
              </span>

              <img
                src={pix.qrBase64}
                alt="QR Code PIX"
                style={{
                  width: "90px",
                  height: "90px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          )}
        </div>
      )}

      {pixLoading && (
        <p
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            marginTop: "6px",
          }}
        >
          Carregando PIX...
        </p>
      )}
    </Container>
  );
}

export { GuiaCode };